import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { App } from 'app/App'
import { msalConfig } from 'auth/config'

import { ApiProvider } from '../providers/ApiProvider'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

const fallbackInstance = new PublicClientApplication(msalConfig)

interface RootProps {
  msalInstance?: PublicClientApplication
  getToken?: () => Promise<string>
}

export const Root = ({ msalInstance = fallbackInstance, getToken }: RootProps) => {
  const instance = msalInstance ?? fallbackInstance

  return (
    <MsalProvider instance={instance}>
      <ApiProvider getToken={getToken}>
        <QueryClientProvider client={queryClient}>
          <div id="nma-home-root">
            <App />
          </div>
        </QueryClientProvider>
      </ApiProvider>
    </MsalProvider>
  )
}
